export const Endpoints = {
  BUSINESS_CATEGORIES: "categories",
  STORES: "stores",
  SUFFIX_CONFIG: "config",
  DOMAINS: "domains",
  INFO: "info",
  GET_ALL_PRODUCTS: "/api-unauthenticated/resources/external/catalog/products",
  UPLOAD_IMAGE: "/api-sp/resources/v2/images?shop_id=",
  getJwtToken: "/support/token",
  merchantRegister:"api-db/resources/v2/dashboard/merchant/register",
};
